import { Edit } from '@mui/icons-material'
import { IconButton, Typography } from '@mui/material'
import React from 'react'
import { iconSizes } from 'shared/style/constants'
import {
    SectionHeaderContainer,
    SectionTitleContainer,
    StyledSubtext,
} from 'shared/style/styled'
import { getPxAsRem } from 'shared/utils'

interface Props {
    handleEditArray: (sectionName: string, cancelEdit?: boolean) => any
    sectionName: string
    title: string
    subTitle: string
}

const PreferenceSectionHeader: React.FC<Props> = ({
    handleEditArray,
    sectionName,
    title,
    subTitle,
}) => {
    return (
        <>
            <SectionHeaderContainer>
                <SectionTitleContainer>
                    <Typography variant="body2">{title}</Typography>
                    <IconButton
                        sx={{ p: getPxAsRem(5) }}
                        size="small"
                        onClick={() => handleEditArray(sectionName)}
                    >
                        <Edit
                            sx={{
                                height: iconSizes.xxsmall,
                                width: iconSizes.xxsmall,
                            }}
                        />
                    </IconButton>
                </SectionTitleContainer>
                <StyledSubtext>
                    <Typography variant="body1">{subTitle}</Typography>
                </StyledSubtext>
            </SectionHeaderContainer>
        </>
    )
}

export default PreferenceSectionHeader
